import { Enums_Addresses } from "data/endpoints";
import IRepository from "data/IRepository";
import AddressFindEnumDTO from "features/shared/enums/dynamic/AddressFindEnumDTO";
import { inversifyContainer } from "infrastructure/ioc/ioc.container";
import { IocTypes } from "infrastructure/ioc/ioc.types";
import { injectable } from "inversify";
import { getQueryParams } from "../helpers/queryParams";
import IAddressService from "./IAddressService";

@injectable()
export default class AddressService implements IAddressService {
  private readonly _addressRepository: IRepository<AddressFindEnumDTO>;

  constructor() {
    this._addressRepository = inversifyContainer.get<IRepository<AddressFindEnumDTO>>(IocTypes.Repository);
  }

  findAddresses(searchedText: string): Promise<AddressFindEnumDTO[]> {
    return this._addressRepository.get({
      url: Enums_Addresses,
      params: getQueryParams("SearchedText", searchedText),
    });
  }
}